/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable radix */
import React from 'react';
import { X } from 'lucide-react';

const ViewSourceModal = ({
  open,
  onClose,
  loading,
  sourceData,
}) => {
  if (!open) return null;
  

  const chapters = sourceData?.chapters || [];
  const difficulty = sourceData?.complexity_level ? String(sourceData.complexity_level).toUpperCase() : '-';
  const category = sourceData?.type ? String(sourceData.type).toUpperCase() : '-';
  const targetExam = sourceData?.target_exam || '-';

  const getStatusMeta = (statusType) => {
    if (Number(statusType) === 1) {
      return { label: 'ACTIVE', className: 'bg-green-50 text-green-700 border-green-200' };
    }
    return { label: 'DRAFT', className: 'bg-gray-50 text-gray-600 border-gray-200' };
  };

  return (
    <div id="view-source-modal" className="fixed inset-0 z-[9999] overflow-y-auto">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === 'Escape') onClose();
        }}
        role="button"
        tabIndex={0}
        aria-label="Close modal"
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-2 sm:p-4">
        <div className="relative bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[95vh] overflow-hidden mx-2 sm:mx-4">
          {/* Header */}
          <div className="flex items-start justify-between p-4 sm:p-5 border-b border-gray-200">
            <h2 className="text-lg sm:text-xl font-semibold text-gray-900">Source Details</h2>
            <button
              id="close-view-source-btn"
              onClick={onClose}
              className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
            >
              <X size={18} />
            </button>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(95vh-72px)]">
            {loading ? (
              <div className="flex items-center justify-center py-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600" />
              </div>
            ) : (
              <div className="p-4 sm:p-6">
                <div className="space-y-4">
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500">Name</div>
                    <div className="text-base sm:text-lg font-semibold text-gray-900">{sourceData?.title || '-'}</div>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500">Description</div>
                    <div className="text-sm sm:text-base text-gray-700">{sourceData?.short_description || '-'}</div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                    <div>
                      <div className="text-xs sm:text-sm text-gray-500 mb-1">Category</div>
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold bg-gray-900 text-white">
                        {category}
                      </span>
                    </div>
                    <div>
                      <div className="text-xs sm:text-sm text-gray-500 mb-1">Difficulty Level</div>
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold border border-gray-200 text-gray-800 bg-gray-50">
                        {difficulty}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500">Target Exam</div>
                    <div className="text-sm sm:text-base text-gray-700">{targetExam}</div>
                  </div>
                </div>

                <div className="my-5 border-t border-gray-200" />

                <div>
                  <div className="text-sm font-semibold text-gray-800 mb-3">
                    Chapters ({chapters.length})
                  </div>
                  <div className="space-y-2">
                    {chapters.length === 0 ? (
                      <div className="border border-gray-200 rounded-lg px-4 py-6 text-sm text-gray-500 text-center">
                        No chapters in this module
                      </div>
                    ) : (
                      chapters.map((chapter) => {
                        const statusMeta = getStatusMeta(chapter?.status_type ?? sourceData?.status_type);
                        return (
                          <div key={chapter.id} id={`chapter-row-${chapter.id}`} className="flex items-center justify-between bg-gray-50 border border-gray-100 rounded-lg px-3 py-2">
                            <div>
                              <div className="text-sm font-medium text-gray-900">
                                {chapter.module_name || chapter.chapter_name}
                              </div>
                              <div className="text-xs text-gray-500">
                                Difficulty: {String(chapter.complexity_level || chapter.difficulty || '-').toUpperCase()}
                              </div>
                            </div>
                            <span className={`text-xs px-2 py-0.5 rounded-md border ${statusMeta.className}`}>
                              {statusMeta.label}
                            </span>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>

                <div className="my-5 border-t border-gray-200" />

                <div className="text-sm font-semibold text-gray-800 mb-3">Statistics</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div id="view-source-total-chapters" className="bg-gray-50 border border-gray-100 rounded-lg p-4">
                    <div className="text-xs text-gray-500">Total Chapters</div>
                    <div className="text-xl font-semibold text-gray-900">
                      {Number(sourceData?.chapters_count) || chapters.length || 0}
                    </div>
                  </div>
                  <div id="view-source-total-questions" className="bg-gray-50 border border-gray-100 rounded-lg p-4">
                    <div className="text-xs text-gray-500">Total Questions</div>
                    <div className="text-xl font-semibold text-gray-900">
                      {Number(sourceData?.questions_count) || 0}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSourceModal;